import { RepositoryFactory } from '../../infrastructure/repositories/RepositoryFactory';
import { InvoiceService } from './InvoiceService';
import { PaymentService } from './PaymentService';
import { PaymentFormService } from './PaymentFormService';
import { DisponibilidadHorariaService } from './DisponibilidadHorariaService';
import { RecordatorioService } from './RecordatorioService';
import { RecordatorioFormService } from './RecordatorioFormService';
import { TokenCache } from '../../infrastructure/services/TokenCache';

/**
 * Proveedor de servicios para la capa de aplicación
 */
export class ServiceProvider {
  /**
   * Obtiene una instancia del servicio de facturas
   * @returns Instancia del servicio de facturas
   */
  public static getInvoiceService(): InvoiceService {
    const invoiceRepository = RepositoryFactory.getInvoiceRepository();
    return new InvoiceService(invoiceRepository);
  }

  /**
   * Obtiene una instancia del servicio de pagos
   * @returns Instancia del servicio de pagos
   */
  public static getPaymentService(): PaymentService {
    const paymentRepository = RepositoryFactory.getPaymentRepository();
    return new PaymentService(paymentRepository);
  }

  /**
   * Obtiene una instancia del servicio de formulario de pago
   * @returns Instancia del servicio de formulario de pago
   */
  public static getPaymentFormService(): PaymentFormService {
    return new PaymentFormService();
  }

  /**
   * Obtiene una instancia del servicio de validación de disponibilidad horaria
   * @returns Instancia del servicio de validación horaria
   */
  public static getDisponibilidadHorariaService(): DisponibilidadHorariaService {
    const repositorio = RepositoryFactory.getDisponibilidadHorariaRepository();
    return new DisponibilidadHorariaService(repositorio);
  }

  /**
   * Obtiene la instancia del servicio de caché de tokens
   * @returns Instancia del servicio de caché de tokens
   */
  public static getTokenCache(): TokenCache {
    return TokenCache.getInstance();
  }

  /**
   * Obtiene una instancia del servicio de recordatorios de pago
   * @returns Instancia del servicio de recordatorios
   */
  public static getRecordatorioService(): RecordatorioService {
    const recordatorioRepository = RepositoryFactory.getRecordatorioRepository();
    return new RecordatorioService(recordatorioRepository);
  }

  /**
   * Obtiene una instancia del servicio de formulario de pago para recordatorios
   * @returns Instancia del servicio de formulario de recordatorios
   */
  public static getRecordatorioFormService(): RecordatorioFormService {
    return new RecordatorioFormService();
  }
} 